import React from 'react'

import { EuiFlexGroup, EuiFlexItem } from '@elastic/eui'

export interface IFormStack {
  children: React.ReactNode
}

const stableKeyOf = (child: React.ReactNode, index: number) => (React.isValidElement(child) && child.key !== null ? child.key : index)

export const FormStack: React.FC<IFormStack> = ({ children }) => (
  <EuiFlexGroup direction='column' gutterSize='l'>
    {React.Children.toArray(children).map((child, index) => (
      <EuiFlexItem grow={false} key={stableKeyOf(child, index)}>
        {child}
      </EuiFlexItem>
    ))}
  </EuiFlexGroup>
)
